import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';

// Component
// import Slider from 'react-rangeslider';

import Popover from 'react-bootstrap/Popover';
//Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

//Algorithm
import { processResponse, processItemResponse } from '../../../../../utilities/processResponse'
//Actions
import { getQuestionList } from '../../../../../actions/SurveyAction';

// To include the default styles
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import { isMobile } from 'react-device-detect';



class ScaleSliderResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scaleSliderValue: 0,
            minValue       : 1,
            maxValue       : 100,
            stepValue      : 1,
            errMsg         : false,
            message        : null,
            remainCount    : 0,
            sumOfOptValue  : 0,
            itemResponses  : {},
            isSlide        : false,
            calculation    : 0,
            isDrag         : false,
            isApiCall      : false,
            width: window.innerWidth,
	    height: window.innerHeight
        };

        this.reviewPage = this.props.questionItemList || [];
        this.stepArr = [];
        this.sliderArr = [];
        this.allCountSlider = [];
        this.answeredQuestion = 0;
        this.responseCount = 0;
        this.rateeCount = 0;
        this.scaleValue = this.state.scaleSliderValue;
        this.isUpdateResponse = false;
    }

    componentWillReceiveProps(nextProps) {

        const { items, configuration, rateeKey } = nextProps;
        var sliderThumb = document.getElementById(`${configuration.className}_${items.key}_${rateeKey}`);
        if (sliderThumb !== null) {
            var sliderThumbChild = sliderThumb.getElementsByClassName("rc-slider-step")[0];
            if (sliderThumbChild.innerHTML === "") {
                var innerDiv = document.createElement('span');
                var innerDiv2 = document.createElement('span');
                innerDiv.className = 'rc-slider-dot';
                innerDiv2.className = 'rc-slider-dot';
                innerDiv.style.cssText='left: 0%; transform: translateX(-50%); border-style: dotted; height: 50px; width: 50px';
                innerDiv2.style.cssText='left: 100%; transform: translateX(-50%); border-style: dotted; height: 50px; width: 50px';
                sliderThumbChild.appendChild(innerDiv);
                sliderThumbChild.appendChild(innerDiv2);
            }
        }
    }

    componentDidMount() {
        try {
            const { configuration, items } = this.props;
            const { maxValue, stepValue } = this.state;
            const scaleMinValue = configuration.itemTypeProperties.min;
            const scaleMaxValue = configuration.itemTypeProperties.max;
            var calculation = maxValue / stepValue;

            for (let i = 0; i <= calculation; i++) {
                this.stepArr[i] = stepValue * i ;
            }

            var middleValue = (Number(scaleMinValue) + Number(scaleMaxValue)) / 2;
            this.setState({ scaleSliderValue: middleValue });

            var tempResValue = document.getElementsByClassName(`_responseValue_${items.key}`)[0];
                tempResValue.textContent = 'ResponseValue:' + null;

            var sliderThumb = document.getElementById(`${configuration.className}_${items.key}_${this.props.rateeKey}`);
            var sliderThumbChild = sliderThumb.getElementsByClassName("rc-slider-handle")[0];
            sliderThumbChild.classList.add('rc-slider-handle-onload');

            var test = setTimeout(() => {
                this.handleGetAllResponse(this.props);
                clearTimeout(test);
            }, 2000);
            this.updateDimensions();
		    window.addEventListener("resize", this.updateDimensions.bind(this));
            if(this.props.ratees.length > 1){
            const { items, activePageKey} = this.props;
            const nextButton = document.getElementsByClassName(`_buttonHideClass_${activePageKey}`)[0];
            if (this.isUpdateResponse !== true) {
                    if (items.requiredIndicator == 2) {
                        nextButton.disabled = true;
                        nextButton.classList.add("_PageNextButtonDisable");
                    }
                }
            }
        } catch (error) {
            console.log("Exception: while calculating all slider response in scale slider response :_", error);
        }
    }

    updateDimensions() {
		if (window.innerWidth < 500) {
			this.setState({ width: 450, height: 102 });
		} else {
			let update_width = window.innerWidth - 100;
			let update_height = Math.round(update_width / 4.4);
			this.setState({ width: update_width, height: update_height });
		}
    }

    handleGetAllResponse = (nextProps) => {
        try {
            const { items, configuration, getAllItemResponseForMultiple, rateeKey, putAllForItemCollection, ratees, getResPonsesOnLoad } = nextProps;
            const { reverse } = configuration.itemTypeProperties;
            const hasReverse = configuration.itemTypeProperties.hasOwnProperty("reverse");
            const scaleMaxValue = configuration.itemTypeProperties.max;
            var sliderThumb = document.getElementById(`${configuration.className}_${items.key}_${rateeKey}`);

            for (const key in getAllItemResponseForMultiple) {
                this.isUpdateResponse = true;

                if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
                    const elementRes = getAllItemResponseForMultiple[key];
                    const { itemResponseSets } = elementRes;

                    if (rateeKey !== undefined && key === rateeKey) {
                        if (itemResponseSets && itemResponseSets !== undefined && itemResponseSets.length > 0) {
                            for (const key in itemResponseSets) {
                                if (itemResponseSets.hasOwnProperty(key)) {
                                    const tempItemResponseSets = itemResponseSets[key];

                                    if (tempItemResponseSets.itemKey.toLowerCase() === items.key.toLowerCase()) {
                                        for (const key in tempItemResponseSets.itemResponses) {

                                            if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {
                                                const temp = tempItemResponseSets.itemResponses[key];

                                                const itemList = this.reviewPage[items.reviewPageKey];

                                                for (const key in itemList) {
                                                    if (itemList.hasOwnProperty(key)) {
                                                        const itemRes = itemList[key];

                                                        if (this.state.isSlide === false) {


                                                            itemRes.isAnswer = temp.responseValue !== null ? true : false;
                                                            itemRes.isRequired = temp.responseValue !== null ? false : itemRes.isRequired;
                                                            itemRes.itemResponses[tempItemResponseSets.itemKey] = tempItemResponseSets.itemResponses;

                                                            var itemType = configuration.itemType;
                                                            var responseSet = this.props.itemResponses[tempItemResponseSets.itemKey] = {};

                                                            processItemResponse(tempItemResponseSets.itemKey, responseSet, tempItemResponseSets.itemResponses, itemType, rateeKey, putAllForItemCollection,"onLoad");
                                                            if(ratees.length > 1) {
                                                                getResPonsesOnLoad(items.key, tempItemResponseSets, rateeKey);
                                                            }
                                                        }
                                                    }
                                                }

                                                var responseValue = temp.responseValue;
                                                var sliderItemValue = hasReverse && reverse === "1" ? (scaleMaxValue - responseValue) : responseValue;
                                                if (this.state.isSlide === false) {
                                                    this.setState({scaleSliderValue:responseValue !== null ? sliderItemValue: this.state.scaleSliderValue});

                                                    if (responseValue !== null) {
                                                        this.scaleValue = this.state.scaleSliderValue;
                                                        var tempResValue = document.getElementsByClassName(`_responseValue_${items.key}`)[0];
                                                            tempResValue.textContent = 'ResponseValue:' + responseValue.toFixed(2);
                                                        var sliderThumbChild = sliderThumb.getElementsByClassName("rc-slider-handle")[0];
                                                            sliderThumbChild.classList.remove('rc-slider-handle-onload');
                                                            sliderThumbChild.classList.add('itemSliderActiveThumb');
                                                            this.handleThumb(sliderItemValue, configuration);
                                                    } else {
                                                        var sliderThumbChild = sliderThumb.getElementsByClassName("rc-slider-handle")[0];
                                                        sliderThumbChild.classList.add('rc-slider-handle-onload');
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } catch (error) {
            console.log("Exception: while updating the getAll response :_", error.message);
        }
    }

    handleChange = (event, configuration, rateeKey, itemKey, eventType) => {
        try {
            const { items, dispatch, dependencies, ratees, putAllForItemCollection, rateeKey } = this.props;
            const { minValue, maxValue, scaleSliderValue } = this.state;
            const { reverse } = configuration.itemTypeProperties;
            const hasReverse = configuration.itemTypeProperties.hasOwnProperty("reverse");
            const response = configuration.scaleResponses[1].response;
            const nextButton = document.getElementsByClassName(`_buttonHideClass_${this.props.activePageKey}`)[0];
            this.setState({
                scaleSliderValue:event,
                isSlide:true,
                isDrag:true,
                isApiCall:true
            });
            this.scaleValue = this.state.scaleSliderValue;
            var selectedValue = event;
              
            var sliderThumb = document.getElementById(`${configuration.className}_${items.key}_${rateeKey}`);
            var sliderThumbChild = sliderThumb.getElementsByClassName("rc-slider-handle")[0];
            sliderThumbChild.classList.remove('rc-slider-handle-onload');
            sliderThumbChild.classList.add('itemSliderActiveThumb');

            var responseSet = null;
            var itemResponses = null;
            var itemType = null;
            /* Manage the question answered response */
            for (const key in this.reviewPage[items.reviewPageKey]) {
                if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
                    const itemList = this.reviewPage[items.reviewPageKey];

                    var itemKey = itemList[key].key;
                    var hasDepend = itemList[key].hasDepend;
                    var selectedItemResponse = selectedValue.toFixed(2);
                    var sliderItemValue = hasReverse && reverse === "1" ? (maxValue - selectedItemResponse) : selectedItemResponse;

                    var convertVal = parseFloat(sliderItemValue);

                    var _responseValue = convertVal.toFixed(0);

                    if (itemList[key].key.toLowerCase() === items.key.toLowerCase()) {

                        for (const rKey in ratees) {

                            if (ratees.hasOwnProperty(rKey)) {
                                const tempRatees = ratees[rKey];

                                if (tempRatees.dataCollectionGuid === rateeKey) {
                                    if (scaleSliderValue !== "") {
                                        itemList[key].isAnswer = true;
                                        itemList[key].isRequired = false;
                                    } else {
                                        itemList[key].isAnswer = false;
                                        itemList[key].isRequired =  itemList[key].requiredIndicator == 2 ? true : false;
                                    }

                                    itemList[key].itemResponses[itemKey] = [{
                                        "itemType"     : configuration.itemType,
                                        "buttonGroup"  : null,
                                        "sequence"     : 1,
                                        "isNa"         : itemList[key].isNA,
                                        "response"     : response,
                                        "responseValue": parseInt(_responseValue),
                                        "openEnd"      : null
                                    }];

                                    responseSet = this.props.itemResponses[itemKey] = {};
                                    itemResponses = itemList[key].itemResponses[itemKey];
                                    itemType = configuration.itemType;

                                    processItemResponse(itemKey, responseSet, itemResponses, itemType, rateeKey, putAllForItemCollection,"onChange");
                                    var circleTimeOut = setTimeout(() => {
                                        this.props.handleItemResponse(items.key, this.props.itemResponses, "itemChange", rateeKey);
                                        clearTimeout(circleTimeOut);
                                    }, 200);
                                }
                            }
                        }
                    } else {
                        if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
                    }
                    this.setState({itemResponses:itemList[key].itemResponses[itemList[key].key]});
                }
            }

            /* Total left count */
            this.reviewPage.map((userResponse, i) => {
                var tempUser = userResponse.userResponse;

                tempUser.map((item, inx) => {
                    if (item.rateeKey === rateeKey && item.itemTag === items.itemTag) {
                        this.allCountSlider[inx + item.rateeKey] = item.totalCount
                    } else {
                        this.allCountSlider = [];
                    }
                    return undefined;
                });
                return undefined;
            });

            /* Reduce count based on total count */
            var allCount = this.allCountSlider.reduce((a, b) => {
                return a + b;
            }, 0);

            this.setState({sumOfOptValue:allCount});

            dispatch(getQuestionList(this.reviewPage));

            this.handleThumb(scaleSliderValue, configuration);

        } catch (error) {
            console.log("Exception: while responding question answer in scale slider response:_", error);
        }
    }

    /**
     * Method to fill right and left circle
     *
     * @param {sliderVal:Number} sliderVal
     */
    handleThumb = (sliderVal, configuration) => {
        try {
            const { items, rateeKey, ratees } = this.props;
            
            const scaleMaxValue = configuration.itemTypeProperties.max;
            const scaleMinValue = configuration.itemTypeProperties.min;
            var middleValue = (Number(scaleMinValue) + Number(scaleMaxValue)) / 2;
             var sliderThumb = document.getElementById(`${configuration.className}_${items.key}_${rateeKey}`);
            var sliderThumbChild = sliderThumb.getElementsByClassName("rangeslider__handle")[0];

            var popoverRight = document.getElementById(`popover-right_${items.key}`);
            var popoverLeft = document.getElementById(`popover-left_${items.key}`);

            var left = sliderThumb.getElementsByClassName('left-circle')[0];
            var right = sliderThumb.getElementsByClassName('right-circle')[0];
            var middle = sliderThumb.getElementsByClassName('middle-circle')[0];
            if(ratees.length < 2)
            {
                this.props.handleRequired();
            }
        } catch (error) {
            console.log("Exception: While slider thumb in scale slider:_", error);
        }
    };


    handleCircleClick = (configuration, type) => {
        try {
            const { items, rateeKey } = this.props;
            const scaleMaxValue = parseInt(configuration.itemTypeProperties.max) || parseFloat(configuration.itemTypeProperties.max);
            const scaleMinValue = parseInt(configuration.itemTypeProperties.min) || parseFloat(configuration.itemTypeProperties.min);
            var stepValue = parseInt(configuration.itemTypeProperties.increment) || parseFloat(configuration.itemTypeProperties.increment);

            var sliderThumb = document.getElementById(`${configuration.className}_${items.key}_${rateeKey}`);
            var sliderThumbChild = sliderThumb.getElementsByClassName("rangeslider__handle")[0];

            var middleValue = (Number(scaleMinValue) + Number(scaleMaxValue)) / 2;
            var left = sliderThumb.getElementsByClassName('left-circle')[0];
            var right = sliderThumb.getElementsByClassName('right-circle')[0];
            var middle = sliderThumb.getElementsByClassName('middle-circle')[0];
            var tempResValue = document.getElementsByClassName(`_responseValue_${items.key}`)[0];
            // sliderThumbChild.classList.add('itemSliderActiveThumb');

            if (type === "left") {
                this.setState({scaleSliderValue:(scaleMinValue), isSlide:false});
                tempResValue.textContent = 'ResponseValue:' + scaleMinValue;

            } else if (type === "center") {

                this.setState({scaleSliderValue:this.isDrag == false && Number(stepValue) == 100 ? scaleMaxValue : middleValue, isSlide:false, isDrag:true});
                tempResValue.textContent = 'ResponseValue:' + middleValue;
            }else if (type === "right") {                
                console.log("check this method");
                this.setState({scaleSliderValue:(scaleMaxValue), isSlide:false});
                tempResValue.textContent = 'ResponseValue:' + scaleMaxValue;

            } else {

                this.setState({scaleSliderValue:(scaleMaxValue), isSlide:false});
                tempResValue.textContent = 'ResponseValue:' + scaleMaxValue;
            }
            var circleTimeOut = setTimeout(() => {
                this.handleChange(this.state.scaleSliderValue, configuration, null, null, "click");
            this.props.handleItemResponse(items.key, this.props.itemResponses, "itemChange", rateeKey);
                clearTimeout(circleTimeOut);
            }, 200);

        } catch (error) {
            console.log("Exception: While handling slider circle click event:_", error.message);
        }
    }


    onAfterChange = (value,configuration, rateeKey, itemKey, eventType) => {
        const { items } = this.props;
        this.handleChange(value,configuration, rateeKey, itemKey, eventType);
        var sliderThumb = document.getElementById(`${configuration.className}_${items.key}_${rateeKey}`);
        var sliderThumbChild = sliderThumb.getElementsByClassName("rc-slider-handle")[0];
        sliderThumbChild.classList.add('itemSliderActiveThumb');
    };

    componentWillUnmount = () => {
        this.stepArr = [];
        this.sliderArr = [];
        this.allCountSlider = [];
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    render() {
        const { configuration, rateeKey, items, className, ResetScaleSliderValue, itemKey } = this.props;
        const { scaleSliderValue, isDrag } = this.state;
        const { reverse } = configuration.itemTypeProperties;
        const scaleResponseLength = configuration.scaleResponses.length || 0;
        const scaleMinValue = parseInt(configuration.itemTypeProperties.min) || parseFloat(configuration.itemTypeProperties.min);
        const scaleMaxValue = parseInt(configuration.itemTypeProperties.max) || parseFloat(configuration.itemTypeProperties.max);
        var stepValue = parseInt(configuration.itemTypeProperties.increment) || parseFloat(configuration.itemTypeProperties.increment);
        var tempValue = Math.sign(scaleMaxValue);

        return (
           <Fragment>
               <Row mb="2">
                   <Col md="12" id={`${configuration.className}_${items.key}_${rateeKey}`} onClick={this.handleDivClick}>
                    <div className={`_ScaleSlider ${className}`} key={items.key}>
                            {configuration.scalePreSection !== null ? <div dangerouslySetInnerHTML={{__html:processResponse(configuration.scalePreSection)}}></div>:null}

                            <Slider 
                                className={`_ScaleSlider_${items.key} ${className}_${items.key}_${rateeKey} test`}
                                min={scaleMinValue}
                                max={scaleMaxValue}
                                step={stepValue}
                                value={ResetScaleSliderValue !== null ? tempValue !== -1 ? (parseInt(scaleMinValue) + parseInt(scaleMaxValue)) / 2 : 0 : scaleSliderValue}
                                dots={stepValue > 0.01 ? true : false}
                                dotStyle={!isMobile ? {border: "2px ##ccc!important",borderStyle:'dotted', height:50, width:50} : ''}
                                activeDotStyle={{borderColor:'#ccc!important'}}
                                handleStyle={{borderColor: "#ccc!important"}}
                                included={false}
                                onChange={ResetScaleSliderValue !== true ? (event) => this.handleChange(event, configuration, rateeKey, itemKey, "change"):null}
                                onAfterChange={(value) => this.onAfterChange(value, configuration, rateeKey, itemKey, "change")}
                             />

                            {configuration.scalePostSection !== null ? <div dangerouslySetInnerHTML={{__html:processResponse(configuration.scalePostSection)}}></div>:null}
                    </div>
                   </Col>
               </Row>
            <Row>
                   <Col xs="6">                 
                         <div className="slider-left-label" >
                            <Popover onClick={() => this.handleCircleClick(configuration, "left")} id={`popover-left_${items.key}`} className="popover-left" placement="bottom" title={configuration.scaleResponses[scaleResponseLength - 2].hasOwnProperty("responseTooltip") ? configuration.scaleResponses[scaleResponseLength - 2].responseTooltip:"" } style={{ border: "2px solid rgb(230 230 230)"}}>
                                <Popover.Content className="left-circle-na ItemText" dangerouslySetInnerHTML={{__html: configuration.scaleResponses[scaleResponseLength - 2].responseDescription} }>
                                </Popover.Content>
                            </Popover>        

                     </div>
                 </Col>
                   <Col xs="6" >
                  <div className="slider-right-label"  >
                            <Popover onClick={() => this.handleCircleClick(configuration, "right")} id={`popover-right_${items.key}`} className="popover-right" placement="bottom" title={configuration.scaleResponses[scaleResponseLength - 2].hasOwnProperty("responseTooltip") ? configuration.scaleResponses[scaleResponseLength - 2].responseTooltip:"" } style={{ border: "2px solid rgb(230 230 230)"}}>
                                <Popover.Content className="left-circle-na ItemText"  dangerouslySetInnerHTML={{__html:configuration.scaleResponses[scaleResponseLength - 1].responseDescription} } >
                            </Popover.Content>
                            </Popover>
                        </div>
                   </Col>
               </Row>
               <Row className={'_itemTempClass'}>
                    <Col xs="6" className={`text-left _responseValue_${items.key}`}></Col>
                    <Col xs="6" className="text-right">Response:{configuration.scaleResponses[1].response}</Col>
               </Row>
            </Fragment>
        )
    }
}

/**
 * Get the state
 *
 * @param {*} state
 */
const mapStateToProps = state => ({
    ResetScaleSliderValue:state.survey.infiniteSliderValue,
    answeredQuestionCount:state.survey.answeredQuestionCount,
    getAllItemResponse:state.survey.getAllItemResponse,
    getAllItemResponseForMultiple:state.survey.getAllItemResponseForMultiple
});

export default connect(mapStateToProps)(ScaleSliderResponse);
